import { Helmet } from "react-helmet-async";

export const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Kontakt – Skaner giełdowy</title>
        <meta name="description" content={`Formularz kontaktowy`} />
      </Helmet>
      <div className="w-full border-b border-gray-100 py-4">
        <div className="mx-auto flex max-w-5xl items-center px-4 sm:px-6 lg:px-8">
          <div>
            <h1 className="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
              Formularz kontaktowy
            </h1>
          </div>
        </div>
      </div>
      <div className="mx-auto w-full max-w-5xl items-center px-4 py-6 sm:px-6 lg:px-8">
        <form action="#" method="POST" className="w-[600px]">
          <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
            <div className="sm:col-span-2">
              <label
                htmlFor="email"
                className="block text-sm/6 font-semibold text-gray-900"
              >
                Twój adres e-mail<span className="text-red-700">*</span>
              </label>
              <div className="mt-2.5">
                <input
                  required
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                />
              </div>
            </div>
            <div className="sm:col-span-2">
              <label
                htmlFor="message"
                className="block text-sm/6 font-semibold text-gray-900"
              >
                Wiadomość<span className="text-red-700">*</span>
              </label>
              <div className="mt-2.5">
                <textarea
                  required
                  id="message"
                  name="message"
                  rows={4}
                  className="block w-full rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
                  defaultValue={""}
                />
              </div>
            </div>
          </div>
          <div className="mt-6 sm:col-span-2">
            <label
              htmlFor="email"
              className="block text-sm/6 font-semibold text-gray-900"
            >
              Załączniki
            </label>
            <div className="mt-2.5">
              <input
                multiple
                accept=".jpg, .jpeg, .png, .gif, .pdf, .docx, .doc, .txt"
                id="file"
                name="file"
                type="file"
                placeholder="Nie wybrano pliku"
                className="text-sm"
              />
            </div>
          </div>
          <div className="mt-6">
            <button
              type="submit"
              className="block w-full rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Wyślij wiadomość
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
